/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleUpdate } from './RuleUpdate.js';
import {
    RuleUpdateFromJSON,
    RuleUpdateFromJSONTyped,
    RuleUpdateToJSON,
} from './RuleUpdate.js';

/**
 * 
 * @export
 * @interface CreateManualQAResult
 */
export interface CreateManualQAResult {
    /**
     * 
     * @type {Array<RuleUpdate>}
     * @memberof CreateManualQAResult
     */
    rules?: Array<RuleUpdate>;
}

/**
 * Check if a given object implements the CreateManualQAResult interface.
 */
export function instanceOfCreateManualQAResult(value: object): boolean {
    return true;
}

export function CreateManualQAResultFromJSON(json: any): CreateManualQAResult {
    return CreateManualQAResultFromJSONTyped(json, false);
}

export function CreateManualQAResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateManualQAResult {
    if (json == null) {
        return json;
    }
    return {
        
        'rules': json['rules'] == null ? undefined : ((json['rules'] as Array<any>).map(RuleUpdateFromJSON)),
    };
}

export function CreateManualQAResultToJSON(value?: CreateManualQAResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rules': value['rules'] == null ? undefined : ((value['rules'] as Array<any>).map(RuleUpdateToJSON)),
    };
}

